import React from 'react';

const StatsCard = ({ icon: Icon, value, label, description, color = "blue" }) => {
  const colorClasses = {
    blue: "text-blue-600",
    green: "text-green-600",
    purple: "text-purple-600",
    red: "text-red-600",
    orange: "text-orange-600",
    indigo: "text-indigo-600",
    pink: "text-pink-600"
  };

  return (
    <div 
      className="rounded-xl shadow-sm p-3 sm:p-4 lg:p-6"
      style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)' }}
    >
      <div className="flex items-center justify-between mb-1 sm:mb-2">
        <Icon className={colorClasses[color]} size={20} />
        <span className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">{value}</span>
      </div>
      <p className="text-gray-600 text-xs sm:text-sm truncate">{label}</p>
      {description && (
        <p className="text-gray-400 text-xs mt-1 truncate">{description}</p>
      )}
    </div>
  );
};

export default StatsCard;